import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/api/client';
import type { Payables, Receivables } from '@core/api/outstanding';
import { payablesPath, receivablesPath } from '@core/api/queryPaths';

export type {
  CustomerReceivable,
  PayableItem,
  Payables,
  ReceivableItem,
  Receivables,
  VendorPayable,
} from '@core/api/outstanding';

export const outstandingKey = ['outstanding'] as const;

/*
  `staleTime: 0` — money that moves on the booking counter, the bill page and Vendor payments all
  changes these lists, and a list that lags a minute behind a payment just taken reads as wrong.
*/

/** What customers owe the acting branch. */
export function useReceivables(branchId: number | undefined, enabled = true) {
  return useQuery({
    queryKey: [...outstandingKey, 'receive', { branchId }],
    queryFn: () => apiFetch<Receivables>(receivablesPath()),
    enabled: enabled && branchId !== undefined,
    staleTime: 0,
  });
}

/** What the acting branch owes vendors. */
export function usePayables(branchId: number | undefined, enabled = true) {
  return useQuery({
    queryKey: [...outstandingKey, 'pay', { branchId }],
    queryFn: () => apiFetch<Payables>(payablesPath()),
    enabled: enabled && branchId !== undefined,
    staleTime: 0,
  });
}
